import { useCallback, useContext } from "react";
import { SidebarContext } from "../../../../../utils/contexts/sidebar-context";
import type { MomentFormMoment } from "../../../types/moment-form-moment";
import type { SaveButtonProps } from "../types";
import { usePublishDesignHuddleNodes } from "../use-publish-design-huddle";

export function usePublishAction(handleSave: SaveButtonProps["handleSave"]): {
  executePublish: (
    values: MomentFormMoment,
  ) => Promise<{ success: boolean; error?: undefined } | { success: boolean; error: string }>;
} {
  const { setProgramsDirty } = useContext(SidebarContext);
  const publishDesignHuddleNodes = usePublishDesignHuddleNodes();

  const executePublish = useCallback(
    async (values: MomentFormMoment) => {
      const design = values.design;

      // Sync design nodes if not markdown
      if (design && design.type !== "markdown") {
        await publishDesignHuddleNodes(design.root ?? design);
      }

      const result = await handleSave(values);

      if (result?.status === "valid") {
        setProgramsDirty(true);
        return { success: true };
      }

      return {
        success: false,
        error: result?.status === "invalid" ? result.message : "Something went wrong",
      };
    },
    [handleSave, setProgramsDirty, publishDesignHuddleNodes],
  );

  return { executePublish };
}
